var map = {
	"./de-DE/btn_back.png": "4305",
	"./en-GB/btn_back.png": "6e32",
	"./en-US/btn_back.png": "0deb",
	"./es-ES/btn_back.png": "0d0c",
	"./es-MX/btn_back.png": "d175",
	"./fr-CA/btn_back.png": "4437",
	"./fr-FR/btn_back.png": "19cb",
	"./it-IT/btn_back.png": "37dd",
	"./ja-JP/btn_back.png": "95fa",
	"./pt-BR/btn_back.png": "b6ab",
	"./zh-TW/btn_back.png": "5042"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f1c1";